import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { redirect } from 'store/Router/actions';
import { selectLocation } from 'store/Router/selectors';
import useTabsShortcuts from 'Hooks/useTabsShortcuts';
import { Wrapper, Item } from './styled';

const Tab = ({ name, url }) => {
  const location = useSelector(selectLocation);
  const isSelected = location.pathname.includes(url);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(redirect(url));
  };

  return (
    <Item onClick={ handleClick } isActive={ isSelected } data-tour={ name }>
      { name }
    </Item>
  );
};

const TabsList = ({ tabsList }) => {
  const location = useSelector(selectLocation);
  const dispatch = useDispatch();
  const activeTab = tabsList.find((t) => location.pathname.includes(t.url));

  useTabsShortcuts({
    tabs: tabsList,
    activeId: activeTab?.url,
    getId: (tab) => tab.url,
    onChange: (url) => dispatch(redirect(url))
  });

  return (
    <Wrapper>
      { tabsList.map(({ name, url }) => <Tab key={ name } name={ name } url={ url } />) }
    </Wrapper>
  );
};

export default TabsList;
